import { Navigate, Route, Routes } from 'react-router-dom'
import { PlatformShell } from '../platform/PlatformShell'
import { PlansPage } from '../platform/PlansPage'
import { PlanEditorPage } from '../platform/PlanEditorPage'
import { ClientsPage } from '../platform/ClientsPage'
import { NewClientPage } from '../platform/NewClientPage'
import { ClientDetailPage } from '../platform/ClientDetailPage'
import { InvoicesPage } from '../platform/InvoicesPage'
import { InvoiceDetailPage } from '../platform/InvoiceDetailPage'
import { SellerProfilePage } from '../platform/SellerProfilePage'
import { DashboardPage } from '../platform/DashboardPage'
import { DiscountCodesPage } from '../platform/DiscountCodesPage'
import { RequestsPage } from '../platform/RequestsPage'
import { LeadsPage } from '../platform/LeadsPage'
import { AdminLoginPage } from './AdminLoginPage'

/**
 * Le portail d'administration, application À PART (admin.html, vite.admin.config.ts).
 *
 * Il ne partage avec l'application des exploitants que des composants d'affichage : ni ses
 * routes, ni sa session (autre clé de stockage), ni ses écrans métier. Le bundle client, lui,
 * ne contient aucun écran d'ici — un exploitant qui lirait le code servi n'y trouverait pas
 * le panneau. Les adresses gardent leur préfixe /platform : les écrans le portent déjà.
 */
export function AdminApp() {
  return (
    <Routes>
      <Route path="/login" element={<AdminLoginPage />} />
      <Route element={<PlatformShell />}>
        <Route path="/platform" element={<ClientsPage />} />
        <Route path="/platform/plans" element={<PlansPage />} />
        <Route path="/platform/plans/nouvelle" element={<PlanEditorPage />} />
        <Route path="/platform/plans/:id" element={<PlanEditorPage />} />
        <Route path="/platform/clients/nouveau" element={<NewClientPage />} />
        {/* Après « /nouveau » : sinon « nouveau » se ferait prendre pour un identifiant. */}
        <Route path="/platform/clients/:id" element={<ClientDetailPage />} />
        <Route path="/platform/invoices" element={<InvoicesPage />} />
        <Route path="/platform/invoices/:id" element={<InvoiceDetailPage />} />
        <Route path="/platform/billing" element={<SellerProfilePage />} />
        <Route path="/platform/dashboard" element={<DashboardPage />} />
        <Route path="/platform/discounts" element={<DiscountCodesPage />} />
        <Route path="/platform/requests" element={<RequestsPage />} />
        <Route path="/platform/leads" element={<LeadsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/platform" replace />} />
    </Routes>
  )
}
